import { createSelector } from 'reselect';

// eslint-disable-next-line
export const makeGetConfigValue = () => createSelector([getConfigValue], value => value);

const getConfigValue = (state, configGroup, property, defaultValue) => {
  const { config } = state.app;
  if (config && configGroup && config[configGroup] && property && config[configGroup][property]) {
    return config[configGroup][property];
  }
  return defaultValue;
};



// WEBPACK FOOTER //
// ./app/selectors/config.js